import { Outlet } from 'react-router';

import CourseTabs from '@/components/course-tabs';

const CourseLayout = () => {
  return (
    <div className="p-1 lg:p-8">
      <CourseTabs />
      <div>
        <Outlet />
      </div>
    </div>
  );
};

export default CourseLayout;
